import {FormActions} from "@pg-mono/form";

import {SearchFormValuesType} from "../views/PropertyConfigurator";
import {getRoomTypes} from "./get_room_types";
import {getRooms} from "./get_rooms";

export const handleFormChange = (
    value: Partial<SearchFormValuesType>,
    update: FormActions<SearchFormValuesType>["update"],
    formValues: SearchFormValuesType
) => {
    update(value);
    if (value.rooms_area_type_selected) {
        update({rooms: getRooms(value.rooms_area_type_selected)});
    }
    if (value.rooms) {
        update({rooms_area_type_selected: getRoomTypes(value.rooms, formValues.rooms_area_type_selected)});
    }
};
import {FormActions} from "@pg-mono/form";

import {SearchFormValuesType} from "../views/PropertyConfigurator";
import {getRoomTypes} from "./get_room_types";
import {getRooms} from "./get_rooms";

export const handleFormChange = (
    value: Partial<SearchFormValuesType>,
    update: FormActions<SearchFormValuesType>["update"],
    formValues: SearchFormValuesType
) => {
    update(value);
    if (value.rooms_area_type_selected) {
        update({rooms: getRooms(value.rooms_area_type_selected)});
    }
    if (value.rooms) {
        update({rooms_area_type_selected: getRoomTypes(value.rooms, formValues.rooms_area_type_selected)});
    }
};
